import { Popover, Transition } from '@headlessui/react'
import { Icon } from '@iconify/react'
import dayjs from 'dayjs'
import { Fragment } from 'react'

import useCall from '~/hooks/useCall'
import { Recording } from '~/types/recorder'
import { getExtensionFromMimeType } from '~/utils/file'

export default function FloatingUploadRecord() {
  const { recordings } = useCall()

  const downloadBlob = (recording: Recording) => {
    const url = URL.createObjectURL(recording.blob)

    const a = document.createElement('a')
    a.href = url
    a.download = `recording-${recording.counterRunId}-${dayjs(recording.timestamp).format(
      'YYYY-MM-DD-HH-mm-ss',
    )}.${getExtensionFromMimeType(recording.blob.type.split(';')[0])}`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <Popover className="relative">
        {({ open, close }) => (
          <>
            {/* Floating Button */}
            <Popover.Button className="rounded-full bg-jba-blue p-3 text-white shadow-lg transition-transform duration-200 hover:scale-105 hover:bg-jba-blueTicket">
              <Icon icon="mdi:upload" className="h-6 w-6 text-white" />
            </Popover.Button>

            {/* Animated Popover Content */}
            <Transition
              as={Fragment}
              show={open}
              enter="transition-opacity duration-200 ease-out"
              enterFrom="opacity-0 translate-y-2"
              enterTo="opacity-100 translate-y-0"
              leave="transition-opacity duration-150 ease-in"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-2"
            >
              <Popover.Panel className="absolute bottom-16 right-0 mb-2">
                <div className="min-w-[300px] rounded-lg bg-white p-4 shadow-lg">
                  <div className="mb-3 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <Icon icon="mdi:upload" className="h-5 w-5 text-jba-blue" />
                      <span className="font-medium">Antrian upload rekaman</span>
                    </div>
                    <button onClick={() => close()} className="text-gray-500 hover:text-gray-700">
                      <span className="sr-only">Close</span>
                      <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  <div className="max-h-60 space-y-3 overflow-y-auto">
                    {recordings.length ? (
                      recordings.map((recording: Recording) => (
                        <div key={recording.id} className="flex items-center justify-between">
                          <span className="text-sm text-gray-500" onClick={() => downloadBlob(recording)}>
                            {recording.queueNo} - {dayjs(recording.timestamp).format('DD-MM-YYYY HH:mm:ss')}
                          </span>
                          {/* TODO: change to icon */}
                          {recording.isUploaded ? (
                            <Icon icon="lets-icons:check-fill" className="h-5 w-5 text-green-500" />
                          ) : (
                            <Icon icon="svg-spinners:3-dots-bounce" className="h-5 w-5 text-jba-blue" />
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="text-sm text-gray-500">Tidak ada rekaman</div>
                    )}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  )
}
